// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ffa2ddcd","324":"02cb9ef8","350":"233e56d6","541":"4cb3e306","594":"926f1506","599":"33d754e6","656":"199b3629","725":"42cc54a4","837":"9e32732e","916":"e836657b","947":"a7ead138","985":"4f27f56c"}[chunkId] + ".chunk.js";
};